module.exports = __webpack_public_path__ + "img/TwitterIcon.e2c17f06.svg";